// WeatherSystem — daily weather changes, extracted from the old
// WeatherDisplay component so it runs regardless of mounted UI.

import { EventBus, GameEvents } from '../utils/EventBus'
import { useGameStore } from '@/store/gameStore'
import { WeatherType } from '@/config/eventsConfig'
import { Rng, defaultRng, rollWeighted } from '../utils/rng'
import { getRegionMods, type WeatherProfile } from '@/config/regionConfig'

const WEATHER_CHANGE_CHANCE = 0.3
const WEATHER_TYPES: WeatherType[] = ['sunny', 'cloudy', 'rainy', 'stormy']

// Per-region climate (weights aligned to WEATHER_TYPES). 'mild' is the IDENTITY
// profile — exactly the legacy weights — so the default region (costa_sol →
// 'mild') reproduces the original behaviour and the deterministic suite stays
// green. Other profiles bias the climate: the rainy north leans wet (indoor
// courts matter), the desert resort is almost always dry.
export const WEATHER_PROFILES: Record<WeatherProfile, number[]> = {
  mild: [0.5, 0.3, 0.15, 0.05],
  sunny: [0.7, 0.22, 0.07, 0.01],
  rainy: [0.25, 0.3, 0.32, 0.13],
  arid: [0.82, 0.15, 0.025, 0.005],
}

export class WeatherSystem {
  private handler = () => this.maybeChangeWeather()

  constructor(private rng: Rng = defaultRng) {
    EventBus.on(GameEvents.DAY_CHANGED, this.handler)
  }

  destroy() {
    EventBus.off(GameEvents.DAY_CHANGED, this.handler)
  }

  private maybeChangeWeather() {
    if (this.rng() >= WEATHER_CHANGE_CHANCE) return

    const weights = WEATHER_PROFILES[getRegionMods().weatherProfile]
    const weather = rollWeighted(WEATHER_TYPES, weights, this.rng)
    useGameStore.getState().setWeather(weather)
    EventBus.emit(GameEvents.WEATHER_CHANGED, { weather })
  }
}
